





















import { Component, Prop, Vue } from 'vue-property-decorator'
import BlocoDeCodigo from '@/components/webhooks/BlocoDeCodigo.vue'
import {
	ItemDoPainelDeIntegracao,
	rotulosDeOperacao,
	rotulosDeTipo,
} from '@/models/ItemDoPainelDeIntegracao'

@Component({
	components: { BlocoDeCodigo },
})
export default class DialogoDeComandoDoItem extends Vue {
	@Prop({ type: Boolean, default: false }) value!: boolean
	@Prop({ type: Object, default: null }) item!: ItemDoPainelDeIntegracao | null
	@Prop({ type: String, default: '' }) comando!: string

	rotulosDeTipo = rotulosDeTipo
	rotulosDeOperacao = rotulosDeOperacao

	get mostrar() {
		return this.value
	}

	set mostrar(valor: boolean) {
		this.$emit('input', valor)
	}

	get comandoFormatado(): string {
		if (!this.comando) return ''
		try {
			return JSON.stringify(JSON.parse(this.comando), null, 4)
		} catch {
			return this.comando
		}
	}
}
